import { configureStore } from '@reduxjs/toolkit';
import walletReducer from './walletSlice';
import relayerRegistrationReducer from './relayerRegistrationSlice';

export const store = configureStore({
  reducer: {
    wallet: walletReducer,
    relayerRegistration: relayerRegistrationReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
